// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDOkFdSQlJG8UT_NI_8tvKD1XxVyK5wvAE",
    authDomain: "interview-app-4658b.firebaseapp.com",
    projectId: "interview-app-4658b",
    storageBucket: "interview-app-4658b.appspot.com",
    messagingSenderId: "527434042500",
    appId: "1:527434042500:web:7e5f86baf040ea98ff06d1",
    measurementId: "G-G5DXKMJHPD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
